import { Component, OnInit, Renderer2 } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppConfigService } from '../../../../services/app-config.service';
import { Language } from '../../../../models/language.model';
import { LanguageService } from '../../../../services/language.service';
import { StorageService } from 'src/app/shared/services/storage.service';
import { AuthorizationService } from 'src/app/shared/services/authorization.service';

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html'
})
export class LanguageSelectorComponent implements OnInit {

  languages: Language[] = [];

  constructor(
    private language: LanguageService,
    private renderer: Renderer2,
    private translate: TranslateService,
    private storage: StorageService,
    private authorization: AuthorizationService) { }

  ngOnInit() {
    const unorderdLanguages = AppConfigService.settings.availableLanguages.map((l) => {
      const lang = new Language();
      lang.language = l;
      this.translate.get(l).subscribe((value) => lang.name = value);
      return lang;
    });

    this.languages = unorderdLanguages.sort((langA, langB) => {
      if (langA === langB) {
        return 0;
      }
      return langA.name > langB.name ? 1 : -1;
    });
  }

  onLangSelect(language: string) {
    if (this.authorization.isAuthorized()) {
      this.storage.setUiCulture(language);
      this.authorization.refreshToken(language);
    } else {
      this.language.setLanguage(language, this.renderer);
    }
  }

  isCurrentLanguage(language: string) {
    return language === this.language.currentLanguage;
  }
}
